import {DatePipe} from '@angular/common';
import {Injectable} from '@angular/core';
import localeDe from '@angular/common/locales/de';

@Injectable()
export class DateUtil {

  constructor(public datePipe: DatePipe) {
  }

  public static formatDate(date, format?): string {
    let datePipe = new DatePipe('de-DE');
    if (format == undefined || format == null) {
      format = 'yyyy-MM-dd EEEE';
    }
    return datePipe.transform(date, format, 'Europe/Berlin');
  }

  static addDays(date: Date, days: number) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  static removeOffset(zeitstempel: Date) {
    return new Date(zeitstempel.getTime() + (zeitstempel.getTimezoneOffset() * 60 * 1000));
  }
}
